import { createTheme } from '../theme';

export const testTheme = createTheme('en');
